import { apiPost } from '@/utils/httpClient'

export const translationApi = {
    getTranslation(segment: any) {
        return apiPost('translation/translateSegment', segment);
    },

    reloadSegmentTranslations(segment: any) {
        return apiPost('translation/reloadSegmentTranslations', segment);
    },

    saveTranslationStyled(segment: any) {
        return apiPost('translation/addTranslationSegment', segment);
    },

    updateTranslationStyled(segment: any) {
        return apiPost('translation/updateTranslationSegment', segment);
    },

    updateSegmentStyles(segment: any) {
        return apiPost('translation/updateTranslationStyle', segment);
    },

    getTerminology(termins: any) {
        return apiPost('translation/getTerms', termins);
    }
}
